import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { ColorModeProvider } from './theme/ColorModeContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './authConfig';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

// Client ID comes from .env (REACT_APP_GOOGLE_CLIENT_ID). If it's not set,
// Google login is skipped and the existing username/password login
// still works exactly as before.
const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

// msal-browser v3+ requires initialize() to resolve before the instance
// is used anywhere (including by MsalProvider). Without this, the Outlook
// login popup loads but never completes the handshake back to the app.
msalInstance.initialize().then(() => {
    root.render(
        <React.StrictMode>
            <GoogleOAuthProvider clientId={googleClientId}>
                <MsalProvider instance={msalInstance}>
                    <ColorModeProvider>
                        <App />
                    </ColorModeProvider>
                </MsalProvider>
            </GoogleOAuthProvider>
        </React.StrictMode>
    );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();